import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-phone-allocated.component.ajs.html';

const MODULE_NAME = 'agentBookingPhoneAllocated';

class AgentBookingPhoneAllocatedCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingPhoneAllocated implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingPhoneAllocatedCtrl];
}

export default MODULE_NAME;
